import { CSSProperties } from "react";

export const reorderItems = (list: Array<any>, startIndex: number, endIndex: number): Array<any> => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const getListStyle = (): CSSProperties => ({
    position: "relative"
});

export const initialPlaceholderProps: DragAndDropPlaceholderProps = {
    clientX: undefined,
    clientY: undefined,
    clientHeight: undefined,
    clientWidth: undefined
}

export type DragAndDropPlaceholderProps = {
    clientX: number;
    clientY: number;
    clientHeight: number;
    clientWidth: number;
}